import { SEQ_VIEW_LOCK_MSG, type SeqGridView } from './useSeqGridView';

/** Grid-bar note shown while a QC / Prep sequence grid is sorted or filtered
 *  (useSeqGridView), with the one-click way back to the plain run order. */
export function SeqViewNote({ view, total }: { view: SeqGridView<unknown>; total: number }) {
  if (!view.active) return null;
  return (
    <span className="seqview-note" title={SEQ_VIEW_LOCK_MSG}>
      <i className="ti ti-filter" />
      Showing {view.viewRows.length} of {total} — sorted / filtered view, run order unchanged
      <button type="button" className="btn" onClick={view.clear}>Clear</button>
    </span>
  );
}
